import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { WindowPosition } from '../../../enums/window-position';
import { Features } from '../../../enums/features';
import { SettingsService } from '../../../services/settings.service';

@Component({
  standalone: false,
  selector: 'app-settings-appearance-tab',
  templateUrl: './settings-appearance-tab.component.html',
  styleUrls: ['./settings-appearance-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SettingsAppearanceTabComponent implements OnInit {
  @Input()
  public formGroupName: string;
  public form: FormGroup;
  public zoomEnabled: boolean;

  public TranslationKeys = TranslationKeys;

  public positions = [
    {
      id: WindowPosition.BottomRight.toString(),
      name: this.translateService.instant(TranslationKeys.AssistantSettingsPositionBottomRight),
    },
    { id: WindowPosition.TopRight.toString(), name: this.translateService.instant(TranslationKeys.AssistantSettingsPositionTopRight) },
  ];

  public zoomLevels = [
    { id: 1, name: `100%` },
    { id: 1.25, name: `125%` },
    { id: 1.5, name: `150%` },
  ];

  public constructor(
    private rootFormGroup: FormGroupDirective,
    private readonly translateService: TranslateService,
    private readonly settingsService: SettingsService,
  ) {
    this.zoomEnabled = this.settingsService.supportsFeature(Features.ZoomView);
  }

  public ngOnInit(): void {
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }
}
